const GROUPMSG = {
  // widget
  WIDGET_PART_TITLE: 'اطلاع رسانی عمومی از طریق ویجت',
  WIDGET_PART_DESC:
    'با این قابلیت می‌توانید از طریق ویجت رایچت، پیام‌های مشخصی را به همه بازدیدکنندگان وبسایت‌تان بفرستید. این روش، سریع، دقیق و بدون هزینه است. می‌توانید تا ۱۰ پیام گروهی در یک شبانه‌روز ارسال کنید.',

  //whatsapp
  WHATSAPP_PART_TITLE: 'اعلان عمومی از طریق واتساپ',
  WHATSAPP_PART_DESC:
    'پس از اتصال وبسایتتان به واتساپ، این قابلیت امکان ارسال پیام عمومی به تمامی مکالمات فعال در واتساپ را فراهم می‌کند. محدودیت ارسال پیام شامل حداکثر پنج پیام گروهی در یک شبانه‌روز می‌شود.',

  // mutual
  EVENT_TYPE_SELECT_TITLE: 'انتخاب نحوه ارسال',
  EVENT_TYPE_GROUP: 'ارسال گروهی',
  MSG_INPUT_PLACEHOLDER: 'پیام',
  FORM_SUBMIT_BTN: 'ارسال',

  WEBSITE_SELECT_ERROR: 'لطفا وبسایت مورد نظر را انتخاب کنید',
  EMPTY_MSG_ERROR: 'لطفا پیام را وارد کنید',
  EVENT_TYPE_ERROR: 'لطفا نحوه ارسال را انتخاب کنید',
};

export default GROUPMSG;
